<template>
  <div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "bounce",
  data() {
    return {
      launch_proto: "",
    }
  },
  components: {
  },
  created() {
  },
  methods: {
    authorize: function(j,cb) {
      let vue = this;
      if (!j[0] || j[0].action != "auth") {
         cb && cb();
         return;
      }
      vx_api.signOut(window.vx)
       .finally(() => {
         window.vx && delete window.vx.user;
         vx_api.getSelf(window.vx,j[0].creds.me).then(self_res => {
           setLocal("vx_cred_me",j[0].creds.me);
           vue.$user.set(Object.assign({
              role: "authenticatedUser"
           },
           self_res));
           j.shift();
           cb && cb();
         }).catch(e => {
           console.log("error",e);
         }); //getSelf
      }); //signOut
    }
  },
  computed: {
  },
  mounted() {
    let vue = this;
    let params = vue.$router.currentRoute.params;
    let url = (vx.rq_endpoint+"/room/"+params.uid+"/tiny/"+params.key+"?acc="+vx.acc);
    issue_http({url:url, type:"GET", done: function(status,data) {
      /* vx.room.auto_raise -- external
       * vx.room.auto_join  -- external
       * vx.auto_open_panel -- internal to room.js
       * vx.guestQuestion   -- external
       * vx.postAuthAction  -- external
       */
      if (status != 200) {
        vue.$parent.show_notification("The link has expired.", {
          variant: "danger",
          delay: 20000,
        });
        return;
      }
      let j = to_json(data);
      vue.authorize(j, function() {
         if (!j) { return; }
         vx.postAuthAction = j[0];
         vue.$router.push({name: "room"});
      });
    }});

  },
};
</script>

<style lang="scss" scoped>
</style>
